import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { PaymentProcessingInfoManager } from '@ctct/application-layer';
import type { PaymentProcessingInfoHooks, PaymentProcessingInfoPageStore } from '@ctct/state-client-layer';

interface Props {
  initializer: Pick<PaymentProcessingInfoManager, 'paymentProcessingInfoInit'>;
  pageStore: PaymentProcessingInfoPageStore;
  hooks: PaymentProcessingInfoHooks;
}

export const usePaymentProcessingInfoWidget = ({ initializer, pageStore, hooks }: Props) => {
  const { t } = useTranslation();

  const componentProps = useMemo(() => {
    const returnValue = initializer.paymentProcessingInfoInit({ pageStore, t });

    return {
      ...returnValue,
      hooks,
    };
  }, [hooks, initializer, pageStore, t]);

  return componentProps;
};

export type PaymentProcessingInfoWidgetProps = ReturnType<typeof usePaymentProcessingInfoWidget>;
